module.exports = __webpack_public_path__ + "img/stategrey_bg.171d735b.png";